import { useEffect, useState } from 'react';

const TEN_MIN = 10 * 60 * 1000;

// Green "BACK IN" tag for 10 minutes after a hurt player returns (new stats or cleared report).
export const BackInTag = ({ leg }) => {
  const at = leg.back_in?.at ? new Date(leg.back_in.at).getTime() : 0;
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!at || Date.now() - at >= TEN_MIN) return undefined;
    const t = setTimeout(() => setNow(Date.now()), TEN_MIN - (Date.now() - at) + 500);
    return () => clearTimeout(t);
  }, [at]);
  if (!at || now - at >= TEN_MIN || String(leg.performance_status || '').startsWith('FINAL')) return null;
  return (
    <div className="mt-0.5 rounded bg-emerald-500 px-1 text-[9px] font-black leading-4 text-black truncate animate-pulse"
      title={`Back in the game · ${leg.back_in.how}${leg.back_in.clock ? ` · ${leg.back_in.clock}` : ''}`}
      data-testid={`back-in-${leg.id}`}>
      BACK IN · {leg.back_in.how}{leg.back_in.clock ? ` · ${leg.back_in.clock}` : ''}
    </div>
  );
};
